// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        },
        root: {
          '& a': {
            textDecoration: 'none',      // Bỏ gạch chân
            color: '#1A1951',               // Màu chữ cho thẻ <a>
            textDecoration: 'none',        // Đậm cho thẻ <a>
            '&:hover': {
              color: '#D32027',              // Màu khi hover vào thẻ <a>
            }
          },
        },
      }
    }
  };
}
